export const state = {
  orderId: null,
  zip: null,
};